// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3GUkH","buttonLabel":"Button_buttonLabel__3Oc2p"};